<template>
  <Teleport to="body">
    <Transition name="cookie-slide">
      <div v-if="visible" class="cookie-banner" role="dialog" aria-label="Cookie consent">
        <div class="cookie-inner">
          <div class="cookie-text">
            <p class="cookie-title">🍪 We use cookies</p>
            <p class="cookie-body">
              We use essential cookies to keep the platform working and optional analytics cookies
              to improve it. See our
              <RouterLink to="/info/privacy" class="cookie-link" @click.stop>Privacy Policy</RouterLink>
              and
              <RouterLink to="/info/cookies" class="cookie-link" @click.stop>Cookie Policy</RouterLink>
              for details.
            </p>
          </div>
          <div class="cookie-actions">
            <button class="cookie-btn cookie-btn--outline" @click="decline">
              Essential only
            </button>
            <button class="cookie-btn cookie-btn--primary" @click="accept">
              Accept all
            </button>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import posthog from 'posthog-js';

const STORAGE_KEY = 'cookie_consent';
const visible = ref(false);

onMounted(() => {
  if (!localStorage.getItem(STORAGE_KEY)) {
    visible.value = true;
  }
});

function accept() {
  localStorage.setItem(STORAGE_KEY, 'all');
  posthog.opt_in_capturing();
  visible.value = false;
}

function decline() {
  localStorage.setItem(STORAGE_KEY, 'essential');
  posthog.opt_out_capturing();
  visible.value = false;
}
</script>

<style scoped>
.cookie-banner {
  position: fixed;
  bottom: 1.25rem;
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 2rem);
  max-width: 760px;
  background: #0D1628;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 1rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.35);
  z-index: 9999;
  padding: 1rem 1.25rem;
}

.cookie-inner {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  flex-wrap: wrap;
}

.cookie-text {
  flex: 1;
  min-width: 200px;
}

.cookie-title {
  font-size: 0.9rem;
  font-weight: 700;
  color: #F5CC6A;
  margin-bottom: 0.25rem;
}

.cookie-body {
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.5;
}

.cookie-link {
  color: #B8902A;
  text-decoration: underline;
  text-underline-offset: 2px;
}
.cookie-link:hover {
  color: #F5CC6A;
}

.cookie-actions {
  display: flex;
  gap: 0.625rem;
  flex-shrink: 0;
}

.cookie-btn {
  padding: 0.55rem 1.25rem;
  border-radius: 0.625rem;
  font-size: 0.8rem;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.15s ease;
  border: none;
}

.cookie-btn--outline {
  background: transparent;
  color: rgba(255, 255, 255, 0.75);
  border: 1.5px solid rgba(255, 255, 255, 0.25);
}
.cookie-btn--outline:hover {
  border-color: rgba(255, 255, 255, 0.5);
  color: white;
}

.cookie-btn--primary {
  background: #B8902A;
  color: white;
}
.cookie-btn--primary:hover {
  background: #d4a843;
}

/* Slide up animation */
.cookie-slide-enter-active {
  transition: transform 0.35s cubic-bezier(0.34, 1.56, 0.64, 1), opacity 0.3s ease;
}
.cookie-slide-leave-active {
  transition: transform 0.25s ease, opacity 0.25s ease;
}
.cookie-slide-enter-from,
.cookie-slide-leave-to {
  transform: translateX(-50%) translateY(120%);
  opacity: 0;
}
</style>
